import { DatePicker } from "antd";
import dayjs from "dayjs";

const RangePicker = ({ value, onChange }) => (
  <DatePicker.RangePicker
    inputReadOnly
    format="DD-MM-YYYY"
    value={value ? value.map((date) => dayjs(date)) : []}
    onChange={onChange}
    style={{
      width: "100%",
    }}
  />
);

export default RangePicker;
